const React = require('react');
const isNode = (typeof process !== 'undefined');
const Input = require('./../../FormComponents/Input');

class SoekNaering extends React.Component {
    getValues() {
        return {
            orgNum: this.orgNum.value,
            orgType: this.orgType.value,
            typeOfSpace: this.typeOfSpace.value,
            size: this.size.value,
            area: this.area.value,
            numEmployees: this.numEmployees.value
        }
    }
    render() {
        const {hideHeaders, color} = this.props;

        return (
        <div className={`forms__inputContainer forms__inputContainer--${color}`}>
            {!hideHeaders && <h2 className="forms__formHeader">Søk etter næringslokale</h2>}
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="orgNumber" type="text" placeholder="Org.nummer" ref={(orgNum) => this.orgNum = orgNum}/>
            </div>
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="orgType" type="text" placeholder="Virksomhet" ref={(orgType) => this.orgType = orgType}/>
            </div>
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="typeOfSpace" type="text" placeholder="Type lokale" ref={(typeOfSpace) => this.typeOfSpace = typeOfSpace}/>
            </div>
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="size" type="text" placeholder="Størrelse fra - til" ref={(size) => this.size = size}/>
            </div>
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="area" type="text" placeholder="Beliggenhet" ref={(area) => this.area = area}/>
            </div>
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="numEmployees" type="text" placeholder="Antall ansatte" ref={(numEmployees) => this.numEmployees = numEmployees}/>
            </div>
        </div>
        )
    }
}

module.exports = SoekNaering;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/SoekNaering/index.jsx